<select #comboBox
  [(ngModel)]="selectedCodeValue" [disabled]="disabled" [hidden]="!visible" [autofocus]="autofocus"
  (change)="updateBindedField($event);onChange($any($event.target).value);" (blur)="onTouched()"
  [style.width.px]="width" [style.width]="undefined !== width ? width : '100%'"
  [class.combo-box-required]="required" [tabindex]="tabindex">
  <ng-template ngFor let-item [ngForOf]="model.codeList">
    <option value="{{item.CodeValue}}">{{item[labelField]}}</option>
  </ng-template>
</select>
